import React from 'react';

import { getIconPath } from 'src/utils/assetPaths';
import { PRODUCT_IMAGES_TABPANEL_CONTAINER_ID } from '../../constants/elementIds';
import * as styles from './NavigationButtons.styles';

const ICON_ARROW = getIconPath('icons-24-arrow-right.svg');

interface PreviousButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const PreviousButton = ({ onClick }: PreviousButtonProps) => {
  return (
    <button
      aria-controls={PRODUCT_IMAGES_TABPANEL_CONTAINER_ID}
      aria-label="Show previous image"
      css={[styles.navigationButton, styles.prevNavigationButton]}
      onClick={onClick}
      type="button"
    >
      <img alt="" height={24} src={ICON_ARROW} width={24} />
    </button>
  );
};

interface NextButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const NextButton = ({ onClick }: NextButtonProps) => {
  return (
    <button
      aria-controls={PRODUCT_IMAGES_TABPANEL_CONTAINER_ID}
      aria-label="Show next image"
      css={[styles.navigationButton, styles.nextNavigationButton]}
      onClick={onClick}
      type="button"
    >
      <img alt="" height={24} src={ICON_ARROW} width={24} />
    </button>
  );
};
